import { render, staticRenderFns } from "./ModuleForm.vue?vue&type=template&id=3047072a&"
import script from "./ModuleForm.vue?vue&type=script&lang=js&"
export * from "./ModuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports